import { IResource } from 'redux-saga-resources';

import { put, take, takeEvery } from '@zaibot/fsa-saga';
import { call, delay, fork, race } from '../../redux-saga';
import { bookmarksResource } from '../bookmarks/resource';
import { categoriesResource } from '../categories/resource';
import { notesResource } from '../notes/resource';
import { emailArchiveResource } from '../../emailarchive/emails/resource';
import { usergroupResource } from '../../usergroup/resource';
import { Status } from './dialog';

import AUTHENTICATED from '../../auth/actions/AUTHENTICATED';
import LOGGEDOUT from '../../auth/actions/LOGGEDOUT';
import STATUS_HIDE from './actions/HIDE';
import STATUS_SHOW from './actions/SHOW';
import { RaceEffect } from 'redux-saga/effects';

const hideErrorDelay = 2000;
// const hideBusyDelayRead = 500;
const hideBusyDelay = 5000;
const hideSuccessDelay = 2000;

export function* rootSaga(): Iterable<any> {
    yield fork(signalLogout);

    // yield fork(signalEditorBusy, notesEditor);
    yield fork(signalResourceBusy, notesResource);
    yield fork(signalResourceSaveSuccess, notesResource, 'Sucessvol opgeslagen!');
    yield fork(signalResourceSaveFailed, notesResource, 'Niet opgeslagen!');
    yield fork(signalResourceRemoveSuccess, notesResource, 'Sucessvol verwijderd!');
    yield fork(signalResourceRemoveFailed, notesResource, 'Niet verwijderd!');

    yield fork(signalResourceSaveSuccess, bookmarksResource, 'Favoriet sucessvol opgeslagen!');
    yield fork(signalResourceSaveFailed, bookmarksResource, 'Favoriet is niet opgeslagen!');
    yield fork(signalResourceRemoveSuccess, bookmarksResource, 'Favoriet sucessvol verwijderd!');
    yield fork(signalResourceRemoveFailed, bookmarksResource, 'Favoriet is niet verwijderd!');

    yield fork(signalResourceSaveSuccess, categoriesResource, 'Categorie sucessvol opgeslagen!');
    yield fork(signalResourceSaveFailed, categoriesResource, 'Categorie is niet opgeslagen!');
    yield fork(signalResourceRemoveSuccess, categoriesResource, 'Categorie sucessvol verwijderd!');
    yield fork(signalResourceRemoveFailed, categoriesResource, 'Categorie is niet verwijderd!');

    yield fork(signalResourceRemoveSuccess, emailArchiveResource, 'Email sucessvol verwijderd!');
    yield fork(signalResourceRemoveFailed, emailArchiveResource, 'Email is niet verwijderd!');

    yield fork(signalResourceSaveSuccess, usergroupResource, 'Gebruikersgroup succesvol opgeslagen!');
    yield fork(signalResourceSaveFailed, usergroupResource, 'Gebruikersgroup is niet opgeslagen!');    
    yield fork(signalResourceRemoveSuccess, usergroupResource, 'Gebruikersgroep succesvol verwijderd!');
    yield fork(signalResourceRemoveFailed, usergroupResource, 'Gebruikersgroep is niet verwijderd!');
}

function* showMessage(message: string, status: Status, timeout?: number) {
    yield put(STATUS_SHOW({ message, status }));
    const waiting: RaceEffect = yield race({
        autohide: call(delay, timeout),
        cancel: take([STATUS_HIDE, STATUS_SHOW]),
    });
    let waitresult: any = waiting;
    if (waitresult.autohide) {
        yield put(STATUS_HIDE({ }));
    }
}

function* signalLogout() {
    while (true) {
        yield take(AUTHENTICATED);
        // yield call(showMessage, `Successvol ingelogd`, 'success', 1000);
        yield take(LOGGEDOUT);
        yield call(showMessage, `Successvol uitgelogd`, 'success', hideSuccessDelay);
    }
}

function* signalResourceBusy<T>(resource: IResource<T>) {
    yield takeEvery([ resource.actions.CREATE, 
                     resource.actions.UPDATE,
                    // resource.actions.DELETE
                    ], function*(action) {
        // if (isType(action, resource.actions.DELETE))
        //     yield call(showMessage, 'Bezig met verwijderen', 'busy', hideBusyDelay); 
        // else
            yield call(showMessage, 'Bezig met opslaan', 'busy', hideBusyDelay);      
    });
}

function* signalResourceSaveSuccess<T>(resource: IResource<T>, message: string) {
    yield takeEvery([resource.actions.CREATE_SUCCESS, resource.actions.UPDATE_SUCCESS], function*() {
        yield put(STATUS_HIDE({ }));
        yield call(showMessage, message, 'success', hideSuccessDelay);
    });
}
function* signalResourceSaveFailed<T>(resource: IResource<T>, message: string) {
    yield takeEvery([resource.actions.CREATE_FAILURE, resource.actions.UPDATE_FAILURE], function*() {
        yield put(STATUS_HIDE({ }));
        yield call(showMessage, message, 'error', hideErrorDelay);
    });
}
function* signalResourceRemoveSuccess<T>(resource: IResource<T>, message: string) {
    yield takeEvery(resource.actions.DELETE_SUCCESS, function*() {
        yield put(STATUS_HIDE({ }));
        yield call(showMessage, message, 'success', hideSuccessDelay);
    });
}
function* signalResourceRemoveFailed<T>(resource: IResource<T>, message: string) {
    yield takeEvery(resource.actions.DELETE_FAILURE, function*() {
        yield put(STATUS_HIDE({ }));
        yield call(showMessage, message, 'error', hideErrorDelay);
    });
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/statusDialog/sagas.tsx